import React from "react";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";

import clsx from "clsx";

import {Brand} from "../Brand";
import {Messaging} from "../Messaging";
import {LocalStorageKeys, usePersistedState} from "../logic/Persistence";


const useLocalStyles = makeStyles((theme) => ({
  explainerRoot: {
    paddingTop: '20px',
    paddingBottom: '16px',
    paddingLeft: '8px',
    paddingRight: '8px',
    minHeight: '80px',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '40px',
      minHeight: '100px',
    },
    ...Brand.styles.inverted,
    fontSize: '1.2rem',
  },
  explainerSerif: {
    ...Brand.typographySerif,
  },
  explainerRootFixed: {
    zIndex: 1100 + 1, // 1100: app bar for Material-ui
    position: 'fixed',
    // top: theme.mixins.toolbar.minHeight,
    top: '56px',
    [theme.breakpoints.up('sm')]: {
      top: '64px',
    },
    left: 0,
    right: 0,
  },
  explainerContainer: {},
  actions: {
    display: 'flex',
    padding: '8px',
    alignItems: 'center',
  },
  rightButton: {
    marginLeft: 'auto',
    // fontWeight: 'bold',
    color: Brand.styles.inverted.color,
  },
}));

export function Post({content, fixed, closePersistedKey, className, actions}: { content: any, fixed?: boolean, closePersistedKey?: string, className?: string, actions?: any }) {
  const classes = useLocalStyles();
  const [closed, setClosed] = usePersistedState(closePersistedKey, false);
  if (closed) return null;
  const useSerifFont = false; // fixed === false
  return (
    <div className={clsx(classes.explainerRoot, (fixed === true) ? classes.explainerRootFixed : '', useSerifFont ? classes.explainerSerif: '', className)}>
      <Container maxWidth="md" className={classes.explainerContainer}>
        {content}
        <div className={classes.actions}>
          {actions}
          {closePersistedKey && <Button size="medium" onClick={() => setClosed(true)} className={classes.rightButton}>Close</Button>}
        </div>
      </Container>
    </div>
  )
}

const ChatPostMapping = {
  'cdf': {
    content: Messaging.text.chatCdf,
    key: LocalStorageKeys.chat_cdf,
  },
  'chef': {
    content: Messaging.text.chatChef,
    key: LocalStorageKeys.chat_chef,
  },
  '#top': {
    content: Messaging.text.chatTwitterTop,
    key: LocalStorageKeys.chat_top,
  },
}

export function ChatPost({snapshot, fixed}: { snapshot: StageTypes.ChatSnapshot, fixed?: boolean }) {
  // map the announcer to a content and a persistence key
  const announcer = snapshot.announcer;
  let content = null;
  let persistenceKey = '';
  if (announcer in ChatPostMapping) {
    const chatPostMapping = ChatPostMapping[announcer];
    content = chatPostMapping.content;
    persistenceKey = chatPostMapping.key;
  } else {
    if (process && process.env && process.env.NODE_ENV === 'development')
      content = JSON.stringify(snapshot, null, '  ').split('\n');
  }
  // skip if couldn't find the mapping
  if (!content) return null;
  // NOTE: the 'key' parameter is needed to force the 'differentiation' (and separate states) of the Per-Chat Post objects
  return <Post key={persistenceKey} content={content} closePersistedKey={persistenceKey} fixed={fixed}/>;
}
